import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BillingIcon, InvoicingIcon, TransactionIcon } from "@icons";
import { MatchableItem, MatchItemType } from "../types";

const TYPE_ICON: Record<
    MatchItemType,
    { Icon: React.ComponentType; label: string } | null
> = {
    [MatchItemType.TRANSACTION]: {
        Icon: TransactionIcon,
        label: "Transaction",
    },
    [MatchItemType.REMAINING]: {
        Icon: TransactionIcon,
        label: "Transaction",
    },
    [MatchItemType.INVOICE]: { Icon: InvoicingIcon, label: "Invoice" },
    [MatchItemType.BILL]: { Icon: BillingIcon, label: "Bill" },
    [MatchItemType.LINE_ITEM]: null,
};

export const TypeCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        if (row.depth > 0) {
            return <ViewTableCell />;
        }

        const entry = TYPE_ICON[row.original.type];
        if (!entry) {
            return <ViewTableCell />;
        }

        const { Icon, label } = entry;

        return (
            <ViewTableCell>
                <Tooltip side="top" content={label}>
                    <span aria-label={label} role="img">
                        <Icon />
                    </span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);
TypeCell.displayName = "TypeCell";
